import { render, staticRenderFns } from "./Facilitie.vue?vue&type=template&id=4967c134&scoped=true"
import script from "./Facilitie.vue?vue&type=script&lang=js"
export * from "./Facilitie.vue?vue&type=script&lang=js"
import style0 from "./Facilitie.vue?vue&type=style&index=0&id=4967c134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4967c134",
  null
  
)

export default component.exports